<template>
  <div class="container-custom moo-sheet-page moo-topup-page" :style="styleObject">
    <div class="content-custom">
      <div class="moo-sheet-shell moo-sheet-shell--with-submit-bar">
        <MooSheetHead
          icon="account_balance_wallet"
          :title="$t('profile.menuTopUp')"
          @close="goBack()"
        />

        <div v-if="isLoadDone">
          <div v-if="isLogined">
            <div class="sheet-balance topup-balance">
              <div class="sheet-balance__info">
                <div class="sheet-balance__label">{{ $t('topup.walletBalance') }}</div>
                <div class="sheet-balance__amount">
                  $ {{ formatAmount(walletBalance) }}
                </div>
              </div>
              <span class="material-icons-round sheet-balance__icon"
                >account_balance_wallet</span
              >
            </div>

            <div class="topup-section-head">
              <div class="topup-section-title">{{ $t('topup.chooseAmount') }}</div>
              <span class="topup-count" v-if="topupList.length">{{
                $t('topup.optionsCount', { count: topupList.length })
              }}</span>
            </div>

            <div class="topup-grid">
              <button
                v-for="(item, index) in topupList"
                :key="index"
                type="button"
                class="topup-option"
                :class="{ 'topup-option--selected': topupCurrentlyHandle === item }"
                @click="selectTopup(item)"
              >
                <span class="topup-option__radio"></span>
                <div class="topup-option__get">
                  + $ {{ formatAmount(item.topup_amount) }}
                </div>
                <div class="topup-option__pay">
                  {{ $t('topup.payAmount', { amount: '$ ' + formatAmount(item.payment_amount) }) }}
                </div>
                <div class="topup-option__bonus" v-if="item.bonus_amount > 0">
                  {{ $t('topup.bonusSuffix', { amount: '$ ' + formatAmount(item.bonus_amount) }) }}
                </div>
              </button>
            </div>

            <div class="topup-terms" v-if="termsConditions">
              <div class="topup-terms__head">
                <span class="material-icons-outlined">info</span>
                <span>{{ $t('rewardCatalogue.termsTitle') }}</span>
              </div>
              <div class="topup-terms__body" v-html="termsConditions"></div>
            </div>

            <SubmitOrderBar
              :label="$t('topup.submit')"
              :disabled="!topupCurrentlyHandle"
              :loading="loaderActive"
              @submit="askTopUpConfirm()"
            />
          </div>
        </div>
      </div>
    </div>

    <ModalConfirmSheet
      :message="confirmMessage"
      icon="account_balance_wallet"
      :confirm-text="$t('topup.submit')"
      :cancel-text="$t('common.cancel')"
      :process-yes="processPaymentTopUp"
    />

    <GuestRewardPrompt
      :show="showGuestPrompt"
      @signin="gotoSignInFromGuestPrompt()"
      @dismiss="goBack()"
    />

    <ModalSuccess
      :processAcction="closeSuccessModal"
      :success="true"
      :message="successMessage"
      :buttonText="$t('topup.done')"
    />

    <div class="position-fixed top-1 end-1 z-index-2">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
    <material-loading :active="loaderActive" />
  </div>
</template>

<script>
import MaterialLoading from "@/components/MaterialLoading.vue";
import MooSheetHead from "@/components/MooSheetHead.vue";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import GuestRewardPrompt from "@/components/GuestRewardPrompt.vue";
import ModalConfirmSheet from "@/components/ModalConfirmSheet.vue";
import ModalSuccess from "@/components/ModalSuccess.vue";
import SubmitOrderBar from "@/components/SubmitOrderBar.vue";
import MemberService from "../services/member.service";
import { STRIPE, AIRWALLEX } from "@/config/const";
import { localStorageName, gotoMemberLogin } from "@/config/utils";
import "bootstrap/dist/js/bootstrap.bundle";
import $ from "jquery";

export default {
  name: "TopUp",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    GuestRewardPrompt,
    ModalConfirmSheet,
    ModalSuccess,
    SubmitOrderBar,
    MooSheetHead,
  },
  data() {
    return {
      isLoadDone: false,
      isLogined: false,
      showGuestPrompt: false,
      merchantCode: "",
      branchCode: "",
      tableCode: "",
      pathType: "",
      tableInfo: null,
      branch: JSON.parse(
        localStorage.getItem(localStorageName("BRANCH_INFO"), "")
      ),
      memberId: 0,
      merchantMember: {},
      topupList: [],
      termsConditions: "",
      topupCurrentlyHandle: null,
      paymentMode: STRIPE,
      loaderActive: false,
      snackbar: null,
      message: "",
      successPaidAmount: null,
      successCreditedAmount: null,
      successBonusAmount: null,
      successStillProcessing: false,
    };
  },
  created() {
    this.merchantCode = this.$store.state.merchantCode;
    this.branchCode = this.$store.state.branchCode;
    this.pathType = this.$route.params.type;
    this.tableCode = this.$route.params.table_code;
    this.tableInfo = JSON.parse(
      localStorage.getItem(
        "table_" +
          (this.merchantCode || "").toLowerCase() +
          "_" +
          (this.branchCode || "").toLowerCase() +
          "_" +
          (this.tableCode || "").toLowerCase()
      ) || "null"
    );

    var memberInfoData = JSON.parse(
      localStorage.getItem(localStorageName("memberInfo")) || "null"
    );
    this.isLogined = !!memberInfoData;
    if (memberInfoData) {
      this.memberId = memberInfoData.id ?? 0;
    }

    // load after redirect back from a hosted checkout (Stripe / Airwallex).
    // AllInPay's cnpSale return_url carries no verification params — its
    // wallet credit is confirmed purely server-side via webhook, same as
    // MyCart.vue's topup flow.
    const stripeId = this.$route.query.session_id ?? null;
    const airwallexIntentId = this.$route.query.airwallex_intent_id ?? null;

    if (!this.isLogined) {
      this.isLoadDone = true;
      this.showGuestPrompt = true;
      return;
    }

    this.checkMemberPermissions();
    this.getTopupList();

    if (stripeId || airwallexIntentId) {
      // getMemberInfo() deliberately NOT called here as well: the credit is
      // applied by a queued job, so a balance read that races the verify shows
      // the pre-payment figure. handleGatewayReturn() reads it once the job is
      // actually done.
      this.handleGatewayReturn(stripeId, airwallexIntentId);
    } else {
      this.getMemberInfo();
    }
  },
  mounted() {
    // M951: the success sheet only ever opens after a completed top-up, so
    // however it is dismissed (Done, X, tap outside) the member goes back to
    // Profile. Navigating on hidden.bs.modal rather than on the button click
    // lets Bootstrap remove its backdrop first — leaving the route while the
    // modal is still open strands .modal-backdrop over the next page.
    const successModal = document.getElementById("success-modal");
    if (successModal) {
      successModal.addEventListener("hidden.bs.modal", this.returnToProfileAfterTopup);
    }
  },
  beforeUnmount() {
    const successModal = document.getElementById("success-modal");
    if (successModal) {
      successModal.removeEventListener("hidden.bs.modal", this.returnToProfileAfterTopup);
    }
  },
  computed: {
    styleObject() {
      return {
        "--color": this.$store.state.mainThemeColorTheme2
          ? this.$store.state.mainThemeColorTheme2
          : this.$store.state.color,
      };
    },
    walletBalance() {
      return this.merchantMember?.amount_in_account ?? 0;
    },
    // Same receipt layout as successMessage below, shown before paying so the
    // confirm sheet and the success sheet read as one flow. ModalConfirmSheet
    // exposes a single v-html slot, hence the HTML string.
    confirmMessage() {
      const item = this.topupCurrentlyHandle;
      if (!item) {
        return "";
      }
      const bonus = Number(item.bonus_amount || 0);
      const rows = [
        {
          icon: "payments",
          label: this.$t("topup.rowYouPay"),
          value: "$ " + this.formatAmount(item.payment_amount),
        },
        {
          icon: "redeem",
          label: this.$t("topup.rowBonus"),
          value: "+$ " + this.formatAmount(bonus),
          bonus: bonus > 0,
        },
        {
          icon: "account_balance_wallet",
          label: this.$t("topup.rowWalletAfter"),
          value:
            "$ " +
            this.formatAmount(
              Number(this.walletBalance || 0) + Number(item.topup_amount || 0)
            ),
        },
      ];

      const rowsHtml = rows
        .map(
          (r) => `
        <div class="ps-row">
          <span class="material-icons-outlined ps-row-icon">${r.icon}</span>
          <span class="ps-row-label">${r.label}</span>
          <span class="ps-row-value${r.bonus ? " ps-row-value--bonus" : ""}">${r.value}</span>
        </div>`
        )
        .join("");

      return `
        <span class="ps-title">${this.$t("topup.confirmTitle")}</span>
        <span class="ps-amount">+$ ${this.formatAmount(item.topup_amount)}</span>
        <span class="ps-rows">${rowsHtml}</span>
      `;
    },
    // Receipt-style breakdown for the success modal. topup_amount/bonus ride
    // on the success_url query string itself (set in processPaymentTopUp)
    // instead of being re-looked-up from topupList by id after redirect.
    successMessage() {
      const paid = this.successPaidAmount;
      const credited = this.successCreditedAmount ?? paid;
      const bonus = Number(this.successBonusAmount || 0);

      const rows = [
        {
          icon: "payments",
          label: this.$t("topup.rowPaid"),
          value: "$ " + this.formatAmount(paid),
        },
        {
          icon: "redeem",
          label: this.$t("topup.rowBonus"),
          value: "+$ " + this.formatAmount(bonus),
          bonus: bonus > 0,
        },
      ];
      rows.push({
        icon: "account_balance_wallet",
        label: this.$t("topup.rowNewBalance"),
        value: "$ " + this.formatAmount(this.walletBalance),
      });

      const rowsHtml = rows
        .map(
          (r) => `
        <div class="ps-row">
          <span class="material-icons-outlined ps-row-icon">${r.icon}</span>
          <span class="ps-row-label">${r.label}</span>
          <span class="ps-row-value${r.bonus ? " ps-row-value--bonus" : ""}">${r.value}</span>
        </div>`
        )
        .join("");

      // Only when the queue never reported back inside the wait window — the
      // money is taken and the job is still coming, so promising a final
      // balance here would be the same lie the old flow told.
      const note = this.successStillProcessing
        ? `<span class="ps-note">${this.$t("topup.stillProcessing")}</span>`
        : "";

      return `
        <span class="ps-title">${this.$t("topup.successTitle")}</span>
        <span class="ps-amount">+$ ${this.formatAmount(credited)}</span>
        <span class="ps-rows">${rowsHtml}</span>
        ${note}
      `;
    },
  },
  methods: {
    formatAmount(amount) {
      return new Intl.NumberFormat("en", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(amount || 0);
    },
    goBack() {
      // Not router.go(-1): after a Stripe/Airwallex redirect back to this
      // page, browser history points at the external checkout page (or
      // nothing), not Profile — so this pushes there directly instead,
      // same pattern Profile.vue's gotoTopUp()/gotoMyReward() use.
      this.$router.push(this.profileRoute());
    },
    profileRoute() {
      return {
        name: "Profile",
        params: {
          merchant_code: this.$store.state.merchantCode,
          type: this.pathType,
          branch_code: this.branchCode,
          table_code: this.tableCode,
        },
      };
    },
    returnToProfileAfterTopup() {
      // replace, not push: the entry being left is the gateway return URL
      // (?session_id / ?airwallex_intent_id), and Back from Profile must not
      // land on it and re-run the verify + success sheet.
      this.$router.replace(this.profileRoute());
    },
    gotoSignInFromGuestPrompt() {
      this.showGuestPrompt = false;
      gotoMemberLogin("top-up", false, "login");
    },
    selectTopup(item) {
      this.topupCurrentlyHandle = item;
    },
    checkMemberPermissions() {
      MemberService.checkMemberPermissions().then(
        (response) => {
          if (
            response.data.result.isSuccess &&
            !response.data.data.includes("Top-up")
          ) {
            this.goBack();
          }
        },
        () => {}
      );
    },
    getMemberInfo() {
      return MemberService.getMemberInfo(this.merchantCode).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.merchantMember = response.data.data.merchant_member;
            if (response.data.data.member?.id) {
              this.memberId = response.data.data.member.id;
            }
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.isLoadDone = true;
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
          this.isLoadDone = true;
        }
      );
    },
    getTopupList() {
      MemberService.getTopupList().then(
        (response) => {
          this.topupList = response.data.data.topup ?? [];
          this.termsConditions = response.data.data.termsConditions ?? "";
          if (!this.topupCurrentlyHandle && this.topupList.length) {
            this.topupCurrentlyHandle = this.topupList[0];
          }
          this.paymentMode = parseInt(
            response.data.data.default_payment_mode
          ) || STRIPE;
        },
        (error) => {
          // Was a console.log: the member saw an empty amount grid with no
          // explanation and no way to tell a slow network from a merchant that
          // sells no packages.
          this.snackbar = "danger";
          this.message =
            error?.response?.data?.result?.message ?? this.$t("topup.loadError");
          this.setTimeOutNotification();
        }
      );
    },
    // Confirm before leaving for the payment page. Both sheet buttons carry
    // data-bs-dismiss, so the modal is already closing by the time the redirect
    // starts and never strands its backdrop over the page.
    askTopUpConfirm() {
      if (!this.topupCurrentlyHandle) {
        return;
      }
      $(".btn-confirm-sheet-modal").click();
    },
    processPaymentTopUp() {
      if (!this.topupCurrentlyHandle) {
        return;
      }
      this.loaderActive = true;
      const item = this.topupCurrentlyHandle;

      // Baseline for waitForCredit() after the redirect. The balance cannot be
      // recovered from the page itself once the browser has been away, and the
      // credit lands asynchronously — so without a "before" figure there is no
      // way to tell a wallet that has been credited from one that has not.
      localStorage.setItem(
        localStorageName("TOPUP_BALANCE_BEFORE"),
        String(this.walletBalance ?? 0)
      );

      const merchantCode = this.$store.state.merchantCode;
      var url = location.protocol + "//" + location.host + "/" + merchantCode;
      var urlCancel =
        location.protocol + "//" + location.host + "/" + merchantCode;

      if (this.tableInfo) {
        url += "/QR/" + this.branchCode + "/" + this.tableCode + "/top-up";
        urlCancel +=
          "/QR/" + this.branchCode + "/" + this.tableCode + "/top-up";
      } else {
        url += "/" + this.branchCode + "/top-up";
        urlCancel += "/" + this.branchCode + "/top-up";
      }

      const payment_amount = new Intl.NumberFormat("en", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(item.payment_amount);

      var dataSend = {
        images: "",
        name: "TOP UP " + payment_amount,
        unit_amount: item.payment_amount,
        quantity: 1,
        branch_code: this.branchCode,
        isTopupOnMember: 1,
        topup_id: item.id,
        member_id: this.memberId,
      };

      // topup_amount/bonus ride along on the return URL itself instead of
      // being re-looked-up from topupList after redirect, so the success
      // receipt shows exactly the package that was actually paid for.
      const successParams =
        "price=" +
        item.payment_amount +
        "&topup_amount=" +
        item.topup_amount +
        "&bonus=" +
        (item.bonus_amount || 0);

      if (this.paymentMode == AIRWALLEX) {
        MemberService.checkoutAirwallex({
          ...dataSend,
          success_url: url + "?" + successParams,
          cancel_url: urlCancel,
        }).then(
          (response) => {
            if (response.data.result.isSuccess) {
              window.location.href = response.data.data.url;
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
              this.loaderActive = false;
            }
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.setTimeOutNotification();
            this.loaderActive = false;
          }
        );
      } else {
        MemberService.checkoutStripe({
          ...dataSend,
          success_url:
            url + "?session_id={CHECKOUT_SESSION_ID}&" + successParams,
          cancel_url: urlCancel,
        }).then(
          (response) => {
            if (response.data.result.isSuccess) {
              window.location.href = response.data.data.url;
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
              this.loaderActive = false;
            }
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.setTimeOutNotification();
            this.loaderActive = false;
          }
        );
      }
    },
    // Verify, then WAIT for the job that actually credits the wallet, then read
    // the balance — in that order. The old flow did all three at once, which is
    // why the wallet card and the success receipt showed the pre-payment figure.
    async handleGatewayReturn(stripeId, airwallexIntentId) {
      this.loaderActive = true;

      const outcome = await this.pollJobStatus(stripeId, airwallexIntentId);

      if (outcome.status === "failed") {
        // isLoadDone rides on this call, so the failure path needs it too or the
        // page stays blank behind the snackbar.
        await this.getMemberInfo();
        this.snackbar = "danger";
        this.message = outcome.message;
        this.setTimeOutNotification();
        this.loaderActive = false;
        return;
      }

      // Second, independent wait. pollJobStatus only knows what the endpoint
      // tells it, and an endpoint that reports no job_status at all — an older
      // deploy, or the MOO ordering api — is indistinguishable from one saying
      // "done". Watching the balance itself needs no cooperation from either.
      const credited = await this.waitForCredit();

      this.successStillProcessing = outcome.status === "pending" || !credited;
      this.showTopupSuccess();
      this.loaderActive = false;
    },
    // Re-read the member until the wallet actually reflects the package that was
    // paid for. Returns false if it never did inside the window — the caller
    // then says so on the receipt instead of printing a figure it cannot stand
    // behind.
    async waitForCredit() {
      const MAX_ATTEMPTS = 8;
      const INTERVAL_MS = 1500;
      const target = this.expectedBalance();

      for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
        if (attempt > 0) {
          await new Promise((resolve) => setTimeout(resolve, INTERVAL_MS));
        }

        await this.getMemberInfo();

        // No baseline to compare against (topped up on another device, storage
        // cleared): one read is all this can honestly do.
        if (target === null) {
          return true;
        }

        // Balances carry 2 decimals; the epsilon keeps a float representation
        // from failing a comparison that is exact in cents.
        if (Number(this.walletBalance || 0) >= target - 0.005) {
          return true;
        }
      }

      return false;
    },
    // Pre-payment balance (stashed before the redirect) + what the package
    // credits (carried on the return URL). Read-once: a leftover baseline from
    // an older top-up would be compared against the wrong balance.
    expectedBalance() {
      const key = localStorageName("TOPUP_BALANCE_BEFORE");
      const stored = localStorage.getItem(key);
      localStorage.removeItem(key);

      const before = stored === null ? NaN : parseFloat(stored);
      const credited = parseFloat(this.$route.query.topup_amount);

      if (isNaN(before) || isNaN(credited)) {
        return null;
      }

      return before + credited;
    },
    // Both gateways go to the MEMBER api, matching processPaymentTopUp above and
    // the voucher / bundle / membership screens. The MOO ordering api neither
    // processes nor logs a top-up (its webhook and its check endpoint both gate
    // on isPaymentItem), so its answer only ever described the payment, never the
    // wallet credit — and for Airwallex it credited nothing at all.
    //
    // The wait itself lives on MemberService: every card flow lands on the same
    // pair of check endpoints and needs the same three-state handling.
    pollJobStatus(stripeId, airwallexIntentId) {
      return MemberService.pollPaymentJobStatus(stripeId, airwallexIntentId);
    },
    showTopupSuccess() {
      // parseFloat (not Number/`??`) on purpose: the backend's own
      // '?stripe_id={CHECKOUT_SESSION_ID}' append lands with a stray '?'
      // when success_url already has a query string, which drags a
      // "?stripe_id=..." tail onto the LAST param's value (only the first
      // '?' in a URL starts its query string). Number()/Intl would choke on
      // that trailing garbage and silently fall back to 0 — parseFloat reads
      // the leading numeric portion and ignores the rest, so this stays
      // correct even before that backend fix has rolled out everywhere.
      this.successPaidAmount = parseFloat(this.$route.query.price) || 0;
      this.successCreditedAmount =
        parseFloat(this.$route.query.topup_amount) || null;
      this.successBonusAmount = parseFloat(this.$route.query.bonus) || 0;
      $(".btn-success-modal").click();
    },
    closeSuccessModal() {
      // ModalSuccess's action button carries no data-bs-dismiss, and the
      // component is shared (SignIn, ...) so it can't gain one without changing
      // every caller — dismiss through its own close button instead, the same
      // way SignIn.vue's closeModal() does. Scoped to #success-modal so it
      // can't also fire the confirm sheet's close button. The move to Profile
      // happens in returnToProfileAfterTopup() once the sheet has fully hidden.
      $("#success-modal .btn-close").click();
    },
    closeSnackbar() {
      this.snackbar = null;
    },
    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
};
</script>

<style scoped>
/* Base MOO page shell — same contract every reskinned view relies on
   (MyReward.vue, MyCart.vue): container-custom fills the viewport height,
   content-custom is the scroll region. Without these two the page never
   scrolls as a flex child and a position:fixed footer measures against the
   viewport instead of this view, which is what clipped "8 options" against
   the screen edge and hid the terms text behind the pay bar before. */
.container-custom {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.content-custom {
  flex: 1;
  overflow: auto;
}

/* Tokens derived from the merchant brand colour, same color-mix recipe as
   MyReward.vue's "theme2" reskin (--rw-*) so this screen tracks whatever
   palette the merchant is on instead of a fixed brown. */
.moo-topup-page {
  /* Aliases onto the shared set in assets/css/moo-sheet.css so the
     colour recipe lives in exactly one place. */
  --tp: var(--sheet);
  --tp-08: var(--sheet-08);
  --tp-12: var(--sheet-12);
  --tp-border: var(--sheet-border);
  --tp-inset: var(--sheet-inset);
}



/* Spacing is this screen's own; the card itself comes from moo-sheet.css. */
.topup-balance {
  margin-bottom: 24px;
}

.topup-section-head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.5rem;
  margin-bottom: 12px;
}
.topup-section-title {
  font-weight: 700;
  color: #241a12;
}
.topup-count {
  font-size: 12px;
  color: #857372;
  flex-shrink: 0;
  white-space: nowrap;
}

.topup-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 20px;
}
.topup-option {
  position: relative;
  background: #ffffff;
  border: 1.5px solid var(--tp-border);
  border-radius: 16px;
  padding: 14px 34px 12px 12px;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease,
    transform 0.1s ease;
}
.topup-option:active {
  transform: scale(0.98);
}
.topup-option--selected {
  border-color: var(--tp);
  background: var(--tp-08);
}
.topup-option__radio {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1.5px solid var(--tp-border);
  background: #fff;
  flex-shrink: 0;
}
.topup-option--selected .topup-option__radio::after {
  content: "";
  display: block;
  width: 8px;
  height: 8px;
  margin: 3px auto;
  border-radius: 50%;
  background: var(--tp);
}
.topup-option__get {
  font-size: 17px;
  font-weight: 800;
  margin-top: 4px;
  color: #241a12;
  word-break: break-word;
}
.topup-option__pay {
  font-size: 12px;
  color: #857372;
  margin-top: 2px;
}
.topup-option__bonus {
  display: inline-block;
  margin-top: 8px;
  font-size: 10.5px;
  font-weight: 700;
  color: var(--tp);
  background: var(--tp-12);
  padding: 3px 8px;
  border-radius: 8px;
}

.topup-terms {
  background: var(--tp-08);
  border: 1px solid var(--tp-border);
  border-radius: 12px;
  padding: 11px 13px;
}
.topup-terms__head {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 7px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--tp);
}
.topup-terms__head .material-icons-outlined {
  font-size: 14px;
  flex-shrink: 0;
}
.topup-terms__body {
  min-width: 0;
  font-size: 11px;
  line-height: 1.55;
  color: #6b6868;
}

/* termsConditions is raw merchant-authored HTML (v-html), so scoped styles do
   not reach it without :deep().
   
   The blanket font-size reset is the point of this block: the text comes out of
   a rich-text editor and routinely carries its own sizing — inline
   style="font-size:16px", <h2>, <big> — which rendered this note at body size
   inside a 11px chrome slot. Nothing but !important beats an inline style, and
   this is a fixed-size box where merchant typography has no say. Weight, colour
   and italics are left alone so emphasis still reads. */
.topup-terms__body :deep(*) {
  font-size: inherit !important;
  line-height: inherit;
  font-family: inherit;
}
.topup-terms__body :deep(p) {
  margin: 0 0 5px;
}
.topup-terms__body :deep(p:last-child) {
  margin-bottom: 0;
}
.topup-terms__body :deep(h1),
.topup-terms__body :deep(h2),
.topup-terms__body :deep(h3),
.topup-terms__body :deep(h4) {
  margin: 0 0 4px;
  font-weight: 700;
  color: #4a4342;
}
.topup-terms__body :deep(ul),
.topup-terms__body :deep(ol) {
  margin: 0 0 5px;
  padding-left: 16px;
}
.topup-terms__body :deep(li) {
  margin-bottom: 2px;
}
.topup-terms__body :deep(a) {
  color: var(--tp);
  font-weight: 600;
  text-decoration: underline;
}
/* A pasted table or long unbroken URL must not widen the card. */
.topup-terms__body :deep(img),
.topup-terms__body :deep(table) {
  max-width: 100%;
}
.topup-terms__body {
  overflow-wrap: anywhere;
}

</style>
